import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errMsg, fmtDate, inr } from "@/lib/api";
import { useAdminApi } from "@/lib/admin";
import { useLoad, PageHead, DataTable, Td } from "@/components/admin/kit";

export default function Commissions({ isAdmin }) {
  const call = useAdminApi();
  const [comm, reloadC] = useLoad("/admin/mlm/commissions");
  const [wds, reloadW] = useLoad("/admin/mlm/withdrawals");
  const [s] = useLoad("/admin/mlm/settings");
  const reverse = async (c) => {
    const reason = window.prompt("Reason for reversing all commissions on this sale?");
    if (!reason) return;
    try {
      await call("post", `/admin/mlm/commissions/source/${c.source_id}/reverse`, { reason });
      reloadC();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const process = async (w, action) => {
    const reference = action === "paid" ? window.prompt("Bank transfer reference") : "";
    if (action === "paid" && !reference) return;
    try {
      await call("patch", `/admin/mlm/withdrawals/${w.id}`, { action, reference });
      reloadW();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-10">
      <div>
        <PageHead title="Commission History" />
        {s && <p className={`mb-4 rounded-xl p-3 text-sm ${s.payouts_enabled ? "bg-emerald-50 text-emerald-900" : "bg-amber-50 text-amber-900"}`} data-testid="payout-status">Payouts: {s.payouts_enabled ? `enabled (approval ${s.compliance_approval_ref})` : "DISABLED until legal & compliance approval"} · Levels: {s.commission_levels.length ? s.commission_levels.map((p, i) => `L${i + 1} ${p}%`).join(", ") : "not configured (no commission is calculated)"}</p>}
        <DataTable head={["Date", "Distributor", "Sale", "Level", "Base", "Commission", "Status", ""]} testid="commissions-table">
          {(comm || []).map((c) => (
            <tr key={c.id}><Td>{fmtDate(c.created_at)}</Td><Td>{c.name}<p className="text-xs text-slate-500">{c.distributor_id}</p></Td><Td>{c.source_ref}<p className="text-xs text-slate-500">{c.source_kind}</p></Td><Td>L{c.level} · {c.percent}%</Td><Td>{inr(c.base_amount)}</Td><Td className="font-semibold">{inr(c.amount)}</Td><Td className="capitalize">{c.status}</Td>
              <Td>{isAdmin && c.status === "eligible" && <Button size="sm" variant="outline" onClick={() => reverse(c)}>Reverse</Button>}</Td></tr>
          ))}
        </DataTable>
      </div>
      <div>
        <PageHead title="Withdrawal Requests" />
        <DataTable head={["Date", "Reference", "Distributor", "Amount", "Bank", "Status", ""]} testid="withdrawals-table">
          {(wds || []).map((w) => (
            <tr key={w.id}><Td>{fmtDate(w.created_at)}</Td><Td>{w.reference}</Td><Td>{w.name}<p className="text-xs text-slate-500">{w.distributor_id}</p></Td><Td>{inr(w.amount)}</Td><Td className="text-xs">{w.bank.account_holder}<br />{w.bank.account_number} · {w.bank.ifsc}</Td><Td className="capitalize">{w.status}{w.payout_reference && ` · ${w.payout_reference}`}</Td>
              <Td>{isAdmin && w.status === "requested" && <div className="flex gap-1"><Button size="sm" onClick={() => process(w, "paid")}>Mark paid</Button><Button size="sm" variant="destructive" onClick={() => process(w, "rejected")}>Reject</Button></div>}</Td></tr>
          ))}
        </DataTable>
      </div>
    </div>
  );
}
